// Centralized content extracted from the Designlayer brand bible.
export const BRAND = {
  name: "Designlayer",
  tagline: "Design. Visualize. Engineer. Manufacture.",
  positioning:
    "Designlayer transforms design ideas into photorealistic experiences and production-ready systems.",
  email: "aye@designlayer.me",
  footerCopy:
    "DESIGNLAYER — Interior design, high-end architectural visualization and cabinetry design-to-production systems. Cabinet Vision development, UCS automation, production drafting, CNC workflow support, custom reporting, rendering and training.",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Visualization", path: "/visualization" },
  { label: "Interior Design", path: "/interior-design" },
  { label: "Cabinet Vision", path: "/cabinet-vision" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Process", path: "/process" },
  { label: "Industries", path: "/industries" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  cabinetry: "https://images.unsplash.com/photo-1613849925580-8ef3bc1cf219?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  kitchen: "https://images.pexels.com/photos/7045356/pexels-photo-7045356.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  renderArch: "https://images.unsplash.com/photo-1640357960494-9242650846d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  textureMood: "https://images.pexels.com/photos/16202290/pexels-photo-16202290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  portfolio1: "https://images.pexels.com/photos/16501692/pexels-photo-16501692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  portfolio2: "https://images.pexels.com/photos/7173661/pexels-photo-7173661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  founder: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bath: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&q=80&w=1400",
  bar: "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&q=80&w=1400",
  millwork: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=1400",
  closet: "https://images.unsplash.com/photo-1558211583-d26f610c1eb1?auto=format&fit=crop&q=80&w=1400",
};

export const CORE_DIVISIONS = [
  {
    overline: "01",
    title: "High-End Architectural Visualization",
    body:
      "Photorealistic interior and cabinetry renderings, lighting and material studies, animations, virtual walkthroughs, presentation imagery and luxury marketing visuals.",
    image: IMAGES.renderArch,
    href: "/visualization",
  },
  {
    overline: "02",
    title: "Interior & Cabinetry Design",
    body:
      "Space planning, kitchen and bath design, custom cabinetry, millwork detailing, material selection, lighting concepts and customer presentations.",
    image: IMAGES.kitchen,
    href: "/interior-design",
  },
  {
    overline: "03",
    title: "Cabinet Vision & Production Systems",
    body:
      "Cabinet Vision libraries, parametric cabinets, UCS automation, production drawings, reports, CNC-ready construction and workflow optimization.",
    image: IMAGES.cabinetry,
    href: "/cabinet-vision",
  },
];

export const TECHNICAL_SNAPSHOT = [
  "Parametric cabinet construction and intelligent assemblies",
  "Custom cabinet and millwork development",
  "Finished-end, filler, scribe, toe-kick and moulding logic",
  "Door, drawer, hinge and hardware automation",
  "Material, edge-band and product-code mapping",
  "Machining rules and CNC-ready construction",
  "Customer approval, production and installation drawing standards",
  "Photorealistic rendering, lighting and material development",
  "Virtual walkthroughs, animation and presentation-ready imagery",
  "Custom reports and shop-floor documentation",
];

export const VISUALIZATION_SERVICES = [
  { title: "Photorealistic Interior Rendering", body: "High-resolution renderings for residential, commercial, hospitality, retail and architectural interiors.", value: "Allows stakeholders to evaluate the design before construction and strengthens proposals, approvals and marketing." },
  { title: "Kitchen & Bathroom Visualization", body: "Detailed presentations showing cabinetry, countertops, backsplashes, appliances, plumbing fixtures, lighting, hardware and finishes.", value: "Supports client decisions and reduces ambiguity around material and design selections." },
  { title: "Custom Cabinetry & Millwork Rendering", body: "Visualization of kitchens, bars, libraries, closets, vanities, entertainment units, wall panelling, reception desks, retail fixtures and specialty millwork.", value: "Presents complex custom work clearly before fabrication." },
  { title: "Luxury Residential Visualization", body: "Premium imagery for custom homes, villas, penthouses, private residences and high-end renovations.", value: "Creates refined design presentations suitable for premium clients and luxury portfolios." },
  { title: "Commercial & Hospitality", body: "Renderings for restaurants, lounges, hotels, bars, retail environments, offices, reception areas and public interiors.", value: "Communicates ambience, branding and operational layout to clients and project teams." },
  { title: "Material & Finish Studies", body: "Comparison of wood species, veneers, paint, metal, stone, glass, fabric, flooring and wall finishes.", value: "Accelerates selection decisions and makes alternatives easier to compare." },
  { title: "Lighting Studies", body: "Daylight, evening, ambient, decorative, concealed, task and accent lighting presentations.", value: "Tests mood, visibility and emphasis before site installation." },
  { title: "Virtual Walkthroughs & VR", body: "Immersive project environments that allow clients to experience scale, circulation and sightlines.", value: "Improves spatial understanding beyond static images." },
  { title: "Animation & Presentation Video", body: "Camera animations showing the interior, cabinetry, materials, lighting and spatial sequence.", value: "Creates engaging content for presentations, websites and social media." },
];

export const DESIGN_SERVICES = [
  { title: "Interior Space Planning", body: "Functional planning, circulation, furniture relationships, focal points and coordination of built-in elements." },
  { title: "Kitchen Design", body: "Cabinet layouts, appliance integration, work zones, storage, materials, lighting and presentation." },
  { title: "Bathroom Design", body: "Vanities, storage, fixture coordination, finishes, lighting and cabinetry details." },
  { title: "Custom Cabinetry", body: "Bars, libraries, entertainment walls, closets, mudrooms, home offices and specialty millwork." },
  { title: "Material & Finish Selection", body: "Cabinet finishes, veneers, stone, metal, glass, flooring, wall finishes and hardware." },
  { title: "Lighting Concepts", body: "Ambient, task, decorative, concealed and accent lighting integrated with the design." },
  { title: "Design Documentation", body: "Plans, elevations, sections, details, schedules, notes and design-intent packages." },
  { title: "Presentation & Approval", body: "Photorealistic renderings, material studies, annotated drawings and client-facing presentations." },
];

export const CV_CAPABILITIES = [
  "Adjustable cabinet width, height and depth",
  "Automatic part resizing and quantity changes",
  "Conditional centre gables and supports",
  "Automatic finished-end conditions",
  "Drawer configurations based on opening height",
  "Door quantities based on cabinet width",
  "Hardware selection by cabinet type or dimensions",
  "Adjustable fillers, scribes, toe kicks and gable returns",
  "Crown and moulding allowances",
  "Appliance-specific, sink, corner and specialty cabinets",
  "Custom display cabinetry and feature assemblies",
];

export const CV_REPORTS = [
  "Cabinet and part lists",
  "Cut lists and bills of materials",
  "Material and edge-band summaries",
  "Hardware and purchasing reports",
  "Door-order and drawer-box lists",
  "Assembly and shop-floor reports",
  "Shipping and installation lists",
  "Production labels and room summaries",
  "ERP-ready exports where feasible",
];

export const INDUSTRIES = [
  { title: "Custom Cabinet Manufacturers", body: "Cabinet Vision systems, drawings, reports, hardware rules, CNC-ready information and visualization." },
  { title: "Architectural Millwork", body: "Residential, commercial, hospitality, retail and institutional custom millwork support." },
  { title: "Kitchen & Bath Companies", body: "Customer presentation, technical drafting, cabinetry specification, production coordination and rendering." },
  { title: "Interior Designers & Architects", body: "Modelling, photorealistic visualization, custom millwork development and technical coordination." },
  { title: "Builders & Developers", body: "Presentation imagery, interior design support, cabinetry documentation and marketing content." },
  { title: "Hospitality & Retail", body: "Atmospheric visualization, bars, restaurants, lounges, reception areas and custom fixtures." },
  { title: "Closet & Storage", body: "Parametric storage systems, accessories, hardware, production documentation and imagery." },
  { title: "Furniture & Product Mfg", body: "Product modelling, studio visualization, material studies and manufacturing documentation." },
  { title: "Design-Build Firms", body: "Coordination between design intent, client presentation, cabinetry detail and production requirements." },
  { title: "Private Residential", body: "Kitchen, bathroom, custom cabinetry and interior visualization services, subject to scope and location." },
];

export const SOFTWARE = {
  cabinetry: ["Cabinet Vision", "Screen-to-Machine (S2M)", "Mozaik", "CNC-ready workflows"],
  modeling: ["SketchUp", "Autodesk 3ds Max", "Blender", "AutoCAD", "Chief Architect"],
  rendering: ["V-Ray", "D5 Render", "Vortek Spaces", "Lumion", "Enscape", "Adobe Photoshop"],
  data: ["Python", "SQL", "JSON / XML", "REST APIs", "Excel VBA", "Git", "Power BI", "ERP / MRP"],
};

export const PROCESS_STEPS = [
  { n: "01", title: "Discovery", body: "Understand the project, company, users, deliverables and constraints." },
  { n: "02", title: "Information Review", body: "Assess drawings, models, libraries, standards, software and examples." },
  { n: "03", title: "Requirements", body: "Document the expected visual, technical and manufacturing outputs." },
  { n: "04", title: "System Architecture", body: "Determine how models, libraries, rules, materials, reports and assets work together." },
  { n: "05", title: "Development", body: "Create the design, model, rendering, cabinet library, UCS, report or drawing system." },
  { n: "06", title: "Internal Testing", body: "Review representative dimensions, materials, views, outputs and edge cases." },
  { n: "07", title: "Client Review", body: "Present previews or test outputs for structured feedback." },
  { n: "08", title: "Validation", body: "Confirm design, visual and production requirements before final release." },
  { n: "09", title: "Delivery", body: "Provide approved files, documentation and training as included." },
  { n: "10", title: "Continuous Improvement", body: "Refine the system as products, machinery, software and business requirements change." },
];

export const PROBLEMS = {
  visualization: [
    "Clients cannot understand the finished design from 2D drawings",
    "Materials and lighting are difficult to evaluate before installation",
    "Portfolio imagery does not reflect the quality of the design",
    "Cabinetry geometry changes during rendering",
    "Concept visuals are attractive but not technically connected",
    "Design alternatives are difficult to compare",
    "Presentations do not communicate luxury or atmosphere",
  ],
  cabinetry: [
    "Approval drawings are created outside Cabinet Vision and rebuilt for production",
    "Cabinet construction varies between users",
    "Hardware is selected manually and inconsistently",
    "Finished ends, toe kicks, fillers, scribes or mouldings are missed",
    "Drawer, hinge and door information must be entered repeatedly",
    "Reports require extensive spreadsheet correction",
    "Customer drawings do not match production information",
    "CNC output requires repeated operator intervention",
    "Grain direction or part orientation is incorrect",
    "Revisions are not updated consistently across systems",
    "Product knowledge exists only in individual employees' memory",
    "Libraries contain duplicate, outdated or uncontrolled cabinets",
  ],
};

export const FAQ_ITEMS = [
  { q: "What does Designlayer do?", a: "Interior design, high-end architectural visualization, Cabinet Vision development, production drafting, CNC workflow support, custom reporting and design-to-production consulting." },
  { q: "What is Cabinet Vision?", a: "A design-to-manufacturing platform used to create cabinetry, drawings, reports, part information and CNC-ready production data." },
  { q: "What is a UCS?", a: "A User-Created Standard is a programmable rule inside Cabinet Vision that can modify cabinets, parts, materials, hardware, machining or other project information automatically." },
  { q: "Can Designlayer create an entire Cabinet Vision library?", a: "Yes. A library project can include cabinets, assemblies, construction methods, materials, hardware, attributes, parameters, drawings, reports and UCS rules." },
  { q: "Can an existing Cabinet Vision system be improved?", a: "Yes. Existing systems can be reviewed for duplicate cabinets, inconsistent construction, outdated hardware, drawing issues, report problems and automation opportunities." },
  { q: "Can customer and production drawings come from the same model?", a: "That is a primary objective of a properly structured Cabinet Vision workflow. Templates, layers, notes and view controls can present appropriate information to customers and production teams." },
  { q: "Does Designlayer create CNC programs?", a: "Designlayer supports the Cabinet Vision and S2M side of CNC-ready production. Machine-specific post-processing and commissioning may require an authorized CNC technician." },
  { q: "Can Designlayer create custom reports?", a: "Yes. Reports can be developed for doors, hardware, parts, materials, purchasing, assembly, shipping, installation and other defined business requirements." },
  { q: "What rendering services are available?", a: "Photorealistic interiors, kitchens, bathrooms, cabinetry, millwork, material studies, lighting studies, animations, virtual walkthroughs and marketing imagery." },
  { q: "Will the approved design be changed during rendering?", a: "When the scope is rendering only, the approved geometry and layout can be preserved. Design changes are made only when design development is included or approved." },
  { q: "What files can be used for rendering?", a: "CAD drawings, SketchUp, 3ds Max, Blender, Cabinet Vision, Mozaik and other compatible models or reference documents." },
  { q: "Does Designlayer provide training?", a: "Yes. Training can be developed around the client's specific Cabinet Vision libraries, standards, reporting procedures and employee roles." },
  { q: "Can services be provided remotely?", a: "Many design, rendering, drawing, reporting, development and training services can be completed remotely. CNC validation may require shop feedback or on-site coordination." },
  { q: "How is pricing determined?", a: "Pricing depends on project scope, model quality, image count, cabinet quantity, construction complexity, rule quantity, drawing requirements, reports, CNC requirements, revisions, documentation and training." },
];

export const PORTFOLIO_ITEMS = [
  { title: "Penthouse Kitchen, Toronto", type: "High-End Rendering", img: IMAGES.kitchen },
  { title: "Walnut Library Cabinetry", type: "Custom Millwork", img: IMAGES.cabinetry },
  { title: "Hospitality Bar, Yorkville", type: "Commercial Visualization", img: IMAGES.bar },
  { title: "Private Residence — Master Bath", type: "Interior Visualization", img: IMAGES.bath },
  { title: "Cabinet Vision Library v3", type: "Production System", img: IMAGES.renderArch },
  { title: "UCS Automation — Drawer Logic", type: "Workflow Improvement", img: IMAGES.textureMood },
  { title: "Boutique Closet Build", type: "Storage Systems", img: IMAGES.closet },
  { title: "Reception Desk — Walnut & Brass", type: "Architectural Millwork", img: IMAGES.millwork },
  { title: "Modern Townhouse Kitchen", type: "Photorealistic Render", img: IMAGES.portfolio1 },
];

export const SERVICE_OPTIONS = [
  "Interior or Kitchen & Bath Design",
  "High-End Architectural Rendering",
  "Material or Lighting Study",
  "Animation or Virtual Walkthrough",
  "Cabinet Vision Library Development",
  "UCS Programming",
  "Approval or Production Drawings",
  "Custom Reports",
  "CNC & S2M Support",
  "Hardware & Material Setup",
  "Workflow Analysis",
  "Training or Ongoing Support",
  "Other",
];
